import { type KeyboardEvent as ReactKeyboardEvent, useRef } from 'react';
import { useIntl } from 'react-intl';

import { DownloadIcon } from '@dynatrace/strato-icons';

import { CATEGORICAL_MESSAGES } from './toolbar-tooltip-texts.js';
import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { useA11yToolbarTabIndex } from '../../../core/hooks/useA11yToolbarTabIndex.js';
import { useCategoricalBarChartRawData } from '../../hooks/useCategoricalBarChartRawData.js';
import { buildAndDownloadCsv } from '../../utils/build-and-download-csv.js';

export type DownloadDataButtonProps = {
  hideTooltip: boolean;
};

export const DownloadDataButton = (props: DownloadDataButtonProps) => {
  const { hideTooltip } = props;
  const downloadDataButtonRef = useRef<HTMLButtonElement>(null);
  const intl = useIntl();
  const categoricalRawData = useCategoricalBarChartRawData();
  const tabIndex = useA11yToolbarTabIndex('download');

  /** Handles the download button when event keydown.*/
  const handleDownloadDataKeyboard = (event: ReactKeyboardEvent) => {
    if (event.key === 'Enter') {
      buildAndDownloadCsv(categoricalRawData);
    }
  };

  /** Handles the download button when clicked. */
  const handleDownloadDataToolbar = () => {
    buildAndDownloadCsv(categoricalRawData);
  };

  return (
    <ChartToolbarRenderer.Control
      ref={downloadDataButtonRef}
      prefixIcon={<DownloadIcon />}
      tooltipText={intl.formatMessage(CATEGORICAL_MESSAGES.downloadAsCsv)}
      testId="chart-toolbar-download"
      onKeyDown={handleDownloadDataKeyboard}
      onClick={handleDownloadDataToolbar}
      hideTooltip={hideTooltip}
      tabIndex={tabIndex}
    />
  );
};

DownloadDataButton['displayName'] = 'DownloadDataButton';
